import { MUTATIONS, STATE } from "./names";

export default {
    [MUTATIONS.SET_IS_VERIFYING_EMAIL](state: any, isVerifyingEmail: boolean) {
        state[STATE.IS_VERIFYING_EMAIL] = isVerifyingEmail;
    },
    [MUTATIONS.SET_EMAIL_SENT_NOTIFICATION_VISIBLE](state: any, isVisible: boolean) {
        state[STATE.EMAIL_SENT_NOTIFICATION_VISIBLE] = isVisible;
    },
}